<template>
  <DsModal
    :open="true"
    :title="$t('components.AddDescriptionModal.title')"
    :primary-button-label="$t('components.AddDescriptionModal.label.button.confirmButton')"
    :secondary-button-label="$t('components.AddDescriptionModal.label.button.cancelButton')"
    height="392px"
    width="590px"
    @secondary="cancelAction()"
    @primary="confirmAction()"
  >
    <template slot="content">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <section class="add-description-modal">
          <div class="add-description-modal__title">
            <v-text-field
              v-model="currentTitle"
              outlined
              :rules="titleRules"
              :counter="titleMaxCharacters"
              :label="$t('components.AddDescriptionModal.form.label.title')"
              type="text"
            />
          </div>

          <div class="add-description-modal__description">
            <v-textarea
              v-model="currentDescription"
              outlined
              height="86px"
              :rules="descriptionRules"
              :counter="descriptionMaxCharacters"
              :label="$t('components.AddDescriptionModal.form.label.description')"
              type="text"
            />
          </div>
        </section>
      </v-form>
    </template>
  </DsModal>
</template>

<script>
import { DsModal } from '@ds/components';

export default {
  name: 'AddDescriptionModal',
  components: {
    DsModal,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    titleMaxCharacters: {
      type: Number,
      default: 40,
    },
    descriptionMaxCharacters: {
      type: Number,
      default: 150,
    },
  },
  data() {
    return {
      currentTitle: '',
      currentDescription: '',
      valid: true,
      titleRules: [
        v => Boolean(v.trim()) || this.$t('components.AddDescriptionModal.form.rule.emptyTitle'),
        v => (v.length <= this.titleMaxCharacters) || this.$t('components.AddDescriptionModal.form.rule.titleMaxCharacters', { titleMaxCharacters: this.titleMaxCharacters }),
      ],
      descriptionRules: [
        v => (v.length <= this.descriptionMaxCharacters) || this.$t('components.AddDescriptionModal.form.rule.descriptionMaxCharacters', { descriptionMaxCharacters: this.descriptionMaxCharacters }),
      ],
    };
  },
  watch: {
    valid() {
      const primaryButton = document.getElementsByClassName('ds-button ds-button--primary ds-button--default')[0];

      primaryButton.disabled = !this.valid;
    },
  },
  mounted() {
    this.currentTitle = '';
    this.currentDescription = '';

    setTimeout(() => {
      this.currentTitle = this.title;
      this.currentDescription = this.description;
    }, 50);
  },
  methods: {
    cancelAction() {
      this.$emit('cancel');
    },
    confirmAction() {
      const title = this.limitForTitle();
      const description = this.limitForDescription();

      this.$emit('confirm', { title, description });
    },
    limitForTitle() {
      return this.limitStringSize(this.currentTitle.trim(), this.titleMaxCharacters);
    },
    limitForDescription() {
      return this.limitStringSize(this.currentDescription, this.descriptionMaxCharacters);
    },
    limitStringSize(string, limit) {
      if (string.length > limit) return string.slice(0, limit);
      return string;
    },
  },
};
</script>

<style scoped lang="scss">
  .add-description-modal {
    display: flex;
    flex-direction: column;

    &__title {
      max-height: 56px;
      margin-top: var(--ds-spacing-stack-nano);
    }

    &__description {
      margin-top: var(--ds-spacing-stack-md);
    }
  }

  ::v-deep {
    .ds-modal__component {
      background-color: var(--ds-color-surface-contrast);
    }

    .ds-modal__header {
      padding-bottom: 0;
    }

    .ds-modal__content,
    .ds-modal__slot-content {
      margin-top: 0;
    }

    .ds-modal__container {
      padding-bottom: 0;
      overflow-y: hidden !important;
    }

    .v-input__slot {
      height: 40px;
      margin: 2px 2px 2px 0;
    }

    .v-text-field {
      &__slot {
        & textarea {
          resize: none;
          line-height: 24px;
          margin: var(--ds-spacing-stack-nano) 0 !important;
        }

        & label:nth-child(1) {
          top: 6px;
        }
      }

      &__details {
        padding: 0 !important;
        margin: 0 !important;
      }

      & .v-input__control .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
      }
    }

    .add-description-modal__title {
      & .v-input--has-state.error--text .v-label {
        top: 6px;
      }

      & .v-label--active:first-child {
        transform: translateY(-20px) scale(1) !important;
        font-size: 12px !important;
        background-color: inherit;
      }
    }
  }
</style>
